import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

interface PaymentNoticeModalProps {
  title: string;
  message: string;
  onClose: () => void;
  primaryAction?: { label: string; onClick: () => void };
}

const PaymentNoticeModal: React.FC<PaymentNoticeModalProps> = ({ title, message, onClose, primaryAction }) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.96 }}
          className="bg-white w-full max-w-sm p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center space-x-2 text-amber-600">
              <AlertTriangle size={18} />
              <h2 className="font-serif text-lg text-primary">{title}</h2>
            </div>
            <button onClick={onClose} className="text-nude hover:text-primary transition-colors">
              <X size={18} />
            </button>
          </div>

          <p className="text-xs text-secondary leading-relaxed mb-6">
            {message}
          </p>

          <div className="flex space-x-3">
            {primaryAction && (
              <button
                onClick={primaryAction.onClick}
                className="btn-primary flex-1 text-xs"
              >
                {primaryAction.label}
              </button>
            )}
            <button
              onClick={onClose}
              className={primaryAction ? 'btn-secondary flex-1 text-xs' : 'btn-primary flex-1 text-xs'}
            >
              {primaryAction ? 'Cancel' : 'Got It'}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PaymentNoticeModal;